import type { YMapFeature, YMapFeatureProps, YMapMarker, YMapMarkerProps } from '@yandex/ymaps3-types'

export function createFeature(options: YMapFeatureProps): YMapFeature {
    const { YMapFeature } = ymaps3
    return new YMapFeature(options)
}

export function createMarker(options: YMapMarkerProps, element: HTMLElement): YMapMarker {
    const { YMapMarker } = ymaps3
    return new YMapMarker(options, element)
}

export default {
    createFeature,
    createMarker
}